export type FilterId = "sugar" | "gluten" | "lactose";

export const tripleFilters: {
  id: FilterId;
  label: string;
  color: string;
  swaps: string[];
  benefit: string;
}[] = [
  {
    id: "sugar",
    label: "Sin azúcar refinada",
    color: "#C7254E",
    swaps: ["Dátiles", "Banana madura", "Azúcar de coco", "Eritritol"],
    benefit: "Energía estable, sin picos ni bajones a las 4 PM.",
  },
  {
    id: "gluten",
    label: "Sin gluten",
    color: "#B98A3E",
    swaps: ["Harina de avena", "Harina de almendra", "Harina de arroz", "Coco rallado"],
    benefit: "Digestión ligera. Adiós a la hinchazón.",
  },
  {
    id: "lactose",
    label: "Sin lactosa",
    color: "#2F8F5B",
    swaps: ["Leche de coco", "Crema de anacardos", "Bebida de almendra", "Aceite de coco"],
    benefit: "Sin pesadez ni malestar estomacal.",
  },
];

/** `cut` = how many points each filter removes from a "bad" metric (base 100). */
export const filterMetrics: {
  label: string;
  kind: "bad" | "good";
  cut: Record<FilterId, number>;
}[] = [
  { label: "Inflamación", kind: "bad", cut: { sugar: 35, gluten: 38, lactose: 22 } },
  { label: "Picos de azúcar", kind: "bad", cut: { sugar: 82, gluten: 10, lactose: 3 } },
  { label: "Pesadez digestiva", kind: "bad", cut: { sugar: 15, gluten: 42, lactose: 38 } },
  { label: "Sabor", kind: "good", cut: { sugar: 0, gluten: 0, lactose: 0 } },
  { label: "Textura esponjosa", kind: "good", cut: { sugar: 0, gluten: 0, lactose: 0 } },
];
